import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import emailjs from 'emailjs-com';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    emailjs.init('mCHYP1GKyAlS0-LW2');
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      message: formData.message,
      reply_to: formData.email
    };
    emailjs.send(
      'service_gpn8ibd', 
      'template_s543dco', 
      templateParams
    )
    .then((response) => {
      console.log('SUCCESS!', response.status, response.text);
      setIsSubmitting(false);
      setFormStatus('success');
      setFormData({ name: '', email: '', message: '' });
      
      setTimeout(() => {
        setFormStatus(null);
      }, 5000);
    })
    .catch((err) => {
      console.error('FAILED...', err);
      setIsSubmitting(false);
      setFormStatus('error');
      
      setTimeout(() => {
        setFormStatus(null);
      }, 5000);
    });
  };
  return (
    <Container className="contact-section">
      <div className={`contact-container ${visible ? 'visible' : ''}`}>
        <Row className="mb-3">
          <Col lg={12} className="text-center">
            <h1 className="section-heading">
              <span className="gradient-text">Contact Me</span>
            </h1>
            <p className="section-subheading">
              Feel free to reach out for collaborations or just a friendly chat
            </p>
          </Col>
        </Row>
        
        <Row className="contact-content">
          <Col md={5} className="contact-info">
            <div className="contact-card">
              <h3>Let's Connect</h3>
              
              <div className="contact-item">
                <div className="contact-icon">✉️</div>
                <div className="contact-text">
                  <h4>Email</h4>
                  <p>vincentleviet@gmail.com</p>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">📱</div>
                <div className="contact-text">
                  <h4>Phone</h4>
                  <p>+1 (416) 802-4672</p>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div className="contact-text">
                  <h4>Location</h4>
                  <p>Toronto, Canada</p>
                </div>
              </div>
              
              <div className="social-links">
                <a href="https://github.com/VincentDev21" target="_blank" rel="noopener noreferrer" className="social-link">
                  <i className="devicon-github-original"></i>
                </a>
                <a href="https://www.linkedin.com/in/vincent-le-21929a215/" target="_blank" rel="noopener noreferrer" className="social-link">
                  <i className="devicon-linkedin-plain"></i>
                </a>
              </div>
            </div>
          </Col>
          
          <Col md={7} className="contact-form-container">
            <div className="form-card">
              <h3>Send Me a Message</h3>              {formStatus === 'success' ? (
                <div className="success-message">
                  <div className="success-icon">✓</div>
                  <p>Thank you for your message! I'll get back to you soon.</p>
                </div>
              ) : formStatus === 'error' ? (
                <div className="error-message">
                  <div className="error-icon">✗</div>
                  <p>Sorry, there was an error sending your message. Please try again later.</p>
                </div>
              ) : (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4">
                    <Form.Label>Your Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      required
                      className="form-input"
                    />
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      required
                      className="form-input"
                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-4">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="What would you like to talk about?"
                      required
                      className="form-input"
                    />
                  </Form.Group>
                  
                  <Button 
                    type="submit" 
                    className="submit-button" 
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                  </Button>
                </Form>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Contact;